import { z } from 'zod';
import { CURRENCIES } from '../enums.js';
export const uuidSchema = z.string().uuid();
/** Trim, and treat empty string as undefined so blank form fields clear cleanly. */
export const optionalText = z
    .string()
    .trim()
    .transform((v) => (v === '' ? undefined : v))
    .optional();
export const moneySchema = z.object({
    amountMinor: z.number().int(),
    currency: z.enum(CURRENCIES),
});
/**
 * The largest page any list route will serve.
 *
 * Dropdowns load their whole list in one request, so this is also the ceiling
 * on a lookup. It is exported because the web client has to ask for exactly
 * this: when the two numbers drifted apart, every company, course and audit
 * dropdown in the app answered 400 and silently rendered empty, and a record
 * simply could not be attached to a company.
 */
export const MAX_PAGE_SIZE = 500;
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(25),
    sort: z.string().optional(),
    dir: z.enum(['asc', 'desc']).default('desc'),
    q: z.string().trim().optional(),
});
export function patchSchemaOf(schema) {
    const shape = {};
    for (const key of Object.keys(schema.shape)) {
        // Zod 4 types the shape as its internal $ZodType, which carries no builder
        // methods; the runtime value is a real ZodType, so it is read through one.
        const field = schema.shape[key];
        const bare = (field instanceof z.ZodDefault
            ? field.removeDefault()
            : field);
        shape[key] = bare.optional();
    }
    // The mapped type above states the real shape; the loop cannot express it.
    return z.object(shape);
}
//# sourceMappingURL=common.js.map